import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { createTheme } from '@rtkwlf/ui';
import { ThemeProvider } from 'styled-components';
import { ROUTE_PATH, UUID_REGEX } from '../../../../../constants';
import { OnboardingSensorAddView } from './AddView';
import { OnboardingSensorEditView } from './EditView';
import { useFetchSensorSection } from '../../../hooks/useFetchSensorSection';
import { useFetchSiteSection } from '../../../hooks/useFetchSiteSection';
import { useFetchAvailableHardware } from '../../../hooks/useFetchAvailableHardware';
import { useFetchProducts } from '../../../hooks/useFetchProducts';
import { useFetchAvailableGenericSensors } from '../../../hooks/useFetchAvailableGenericSensors';

const theme = createTheme(
  {},
  {
    typographyLabelFontSize: '14px',
    typographyLabelTextTransform: 'none',
  },
);

export const OnboardingSensorRouteManager = () => {
  useFetchSensorSection();
  useFetchSiteSection();
  useFetchAvailableHardware();
  useFetchProducts();
  useFetchAvailableGenericSensors();

  return (
    <ThemeProvider theme={theme}>
      <Switch>
        <Route
          exact
          path={ROUTE_PATH.ONBOARDING.SENSORS.NEW}
          component={OnboardingSensorAddView}
        />

        <Route
          exact
          path={`${ROUTE_PATH.ONBOARDING.SENSORS.EDIT}/:uuid(${UUID_REGEX})`}
          component={OnboardingSensorEditView}
        />

        <Redirect to={ROUTE_PATH.ONBOARDING.MAIN} />
      </Switch>
    </ThemeProvider>
  );
};
